module.exports = __webpack_public_path__ + "static/media/sliders.2e62b47a.svg";